import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterModule, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import * as moment from 'moment-timezone'
import { start_logout } from 'src/store/action/auth.action'
import { AppState } from 'src/store/state/app.state'

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentPSTTime: string
  private timer: any

  constructor(public router: Router, private appState: Store<AppState>) {}

  ngOnInit(): void {
    this.clearTimer()
    this.updatePSTTime()
    this.timer = setInterval(() => {
      this.updatePSTTime()
    }, 60000)
  }

  updatePSTTime(): void {
    const now = moment().tz('America/Los_Angeles')
    this.currentPSTTime = now.format('MM/DD/YYYY h:mm A')
  }

  logout(): void {
    this.clearTimer()
    this.appState.dispatch(start_logout({}))
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.timer)
  }
}
